import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    getMembersList,
    membersSuccess,
    membersFailed,
    getMember,
    memberSuccess,
    memberFailed,
    deleteMember,
    memberDeletedSuccessfully,
    memberDeletionFailed,
    createNewMember,
    updateMember,
    memberCreatedUpdated,
    addLinkedMember,
    updateLinkedMember,
    deleteLinkedMember,
    getMembersLookup,
    membersLookupSuccess,
    membersLookupFailed,
    sendPlanLink,
    // planLinkSent,
    planLinkFailed,
    recordCollection,
    recordCollectionSuccess,
    recordCollectionFailed,
    getNewEmail,
    newEmailSuccess,
    newEmailFailed,
} from "../slices/membersSlice";
import {notification} from "antd";

const endpoint = '/admin/members';

function* fetchMembers(action) {
    try {
        const response = yield call(HttpService.get, endpoint, action.payload);
        const {members} = response.data;
        if (members) {
            yield put(membersSuccess(members));
        }
    } catch (error) {
        yield put(membersFailed());
    }
}

function* fetchMembersLookup(action) {
    try {
        const response = yield call(HttpService.get, `${endpoint}/lookup`, action.payload);
        const {members} = response.data;
        if (members) {
            yield put(membersLookupSuccess(members));
        }
    } catch (error) {
        yield put(membersLookupFailed());
    }
}

function* fetchMember(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.get, `${endpoint}/${id}`);
        const {member} = response.data;
        if (member) {
            if (member.joining_form_submitted === false) {
                notification.info({message: 'Member didnt submit the joining form yet'});
            }
            yield put(memberSuccess(member));
        } else {
            yield put(memberFailed());
        }
    } catch (error) {
        yield put(memberFailed());
    }
}

function* requestNewEmailAddress() {
    try {
        const response = yield call(HttpService.get, `${endpoint}/email`);
        const {email} = response.data;
        if (email) {
            yield put(newEmailSuccess(email));
        } else {
            yield put(newEmailFailed());
        }
    } catch (error) {
        yield put(newEmailFailed());
    }
}

function* createMemberRequest(action) {
    try {
        const response = yield call(HttpService.post, `${endpoint}`, action.payload);
        if (response) {
            notification.success({message: 'Member created', description: 'Member created successfully'});
            yield put(memberCreatedUpdated());
        } else {
            yield put(memberFailed());
        }
    } catch (error) {
        yield put(memberFailed());
    }
}

function* updateMemberRequest(action) {
    const {id, payload} = action.payload;
    try {
        const response = yield call(HttpService.post, `${endpoint}/${id}`, payload);
        if (response) {
            notification.success({message: 'Member updated', description: 'Member updated successfully'});
            yield put(memberCreatedUpdated());
        } else {
            yield put(memberFailed());
        }
    } catch (error) {
        yield put(memberFailed());
    }
}

function* deleteMemberRequest(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.del, `${endpoint}/${id}`);
        if (response) {
            notification.success({message: 'Member deleted', description: 'Member deleted successfully'});
            yield put(memberDeletedSuccessfully({id}));
        }
    } catch (error) {
        yield put(memberDeletionFailed());
    }
}

// linked members
function* addLinkedMemberRequest(action) {
    const {id, payload} = action.payload;
    try {
        const response = yield call(HttpService.post, `${endpoint}/linked_members/${id}`, payload);
        if (response) {
            notification.success({message: 'Member added', description: 'Nominated member added successfully'});
        } else {
            yield put(membersFailed(payload));
        }
    } catch (error) {
        yield put(membersFailed(payload));
    }

    try {
        const response = yield call(HttpService.get, `${endpoint}/${id}`);
        const {member} = response.data;
        if (member) {
            yield put(memberSuccess(member));
        }
    } catch (e) {
        // do nothing
    }
}

function* updateLinkedMemberRequest(action) {
    const {id, memberId, payload} = action.payload;
    try {
        const response = yield call(HttpService.post, `${endpoint}/linked_members/${id}/${memberId}`, payload);
        if (response) {
            notification.success({message: 'Member updated', description: 'Linked member updated successfully'});
        }
    } catch (error) {
        yield put(membersFailed());
    }
}

function* deleteLinkedMemberRequest(action) {
    const {id, memberId} = action.payload;
    try {
        const response = yield call(HttpService.del, `${endpoint}/linked_members/${id}/${memberId}`);
        if (response) {
            notification.success({message: 'Member deleted', description: 'Member deleted successfully'});
        }
    } catch (error) {
        yield put(membersFailed());
    }
}

function* sendPlanLinkRequest(action) {
    const {id, planId, age, joining_fee, covered_by_parents} = action.payload;
    const data = {
        age, joining_fee, covered_by_parents
    }
    try {
        const response = yield call(HttpService.put, `${endpoint}/${id}/send_plan_link/${planId}`, data);
        if (response) {
            notification.success({message: 'Link Sent', description: 'Plan link sent successfully'});
        } else {
            yield put(planLinkFailed());
        }
    } catch (error) {
        yield put(planLinkFailed());
    }
}

function* recordCollectionRequest(action) {
    try {
        const response = yield call(HttpService.post, `${endpoint}/record_collection`, action.payload);
        if (response) {
            notification.success({message: 'Collection Recorded', description: 'Collection recorded successfully'});
            yield put(recordCollectionSuccess(response.data));
        } else {
            yield put(recordCollectionFailed());
        }
    } catch (error) {
        yield put(recordCollectionFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getMembersList.type, fetchMembers);
    yield takeLatest(getMembersLookup.type, fetchMembersLookup);
    yield takeLatest(deleteMember.type, deleteMemberRequest);
    yield takeLatest(getMember.type, fetchMember);
    yield takeLatest(createNewMember.type, createMemberRequest);
    yield takeLatest(updateMember.type, updateMemberRequest);

    yield takeLatest(addLinkedMember.type, addLinkedMemberRequest);
    yield takeLatest(updateLinkedMember.type, updateLinkedMemberRequest);
    yield takeLatest(deleteLinkedMember.type, deleteLinkedMemberRequest);

    yield takeLatest(sendPlanLink.type, sendPlanLinkRequest);
    yield takeLatest(recordCollection.type, recordCollectionRequest);

    yield takeLatest(getNewEmail.type, requestNewEmailAddress);

}
